<template>
  <div class="container-balance">
    <CollapsePanel style="padding: 0;" v-model="showMonthChart">
      <div slot="title"><span class="rectangle" style="background:#f09537"></span> 箱量月分布</div>
      <span slot="port">
            <div class="port-checkbox portCheckbox"  v-if="showMonthChart">
              <CheckboxGroup v-model="portIdList">
                <span class="form-label">港口</span>
                <Checkbox
                  v-for="item in portList"
                  :key="item.portId"
                  :label="item.portId"
                  >{{ item.portName }}</Checkbox
                >
              </CheckboxGroup>
            </div>
          </span>
      <div class="container-balance">
        <div>
          <div class="chart-box">
            <div id="container-balance-month-chart" ref="chartEle"></div>
            <span></span>
          </div>
          <div></div>
        </div>
        <Spin size="large" fix v-if="loading"></Spin>
      </div>
    </CollapsePanel>
  </div>
</template>

<script>
import CollapsePanel from "@/components/place-order/collapse-panel";
import ContainerBalanceChart from "@/components/container-balance-chart";
import echarts from "@moon-land/echarts/lib/echarts";
import "@moon-land/echarts/lib/chart/bar";
import "@moon-land/echarts/lib/component/grid";
import "@moon-land/echarts/lib/component/dataZoom";
import "@moon-land/echarts/lib/component/markLine";
import "@moon-land/echarts/lib/component/tooltip";
import dayjs from "dayjs";
import _ from "lodash";
import moment from 'moment'
import {
  fetchContainerHistory,
  fetchContainerPortAndNum,
  fetchMonthContainerHistory,
} from "@/api/containerBalance";

let chartInstance = null;

window.onresize = () => {
  chartInstance && chartInstance.resize();
};

const COLOR_THEME = ["#3fb1e3", "#f00"];
export default {
  props: {
    defaultPortIds: {
      default() {
        return []
      }
    },
    portOptionList: {
      default() {
        return []
      }
    }
  },
  components: {
    CollapsePanel,
    ContainerBalanceChart,
  },
  mounted() {
    
  },
  data() {
    return {
      portList: [],
      portIdList: [],
      loading: false,
      chartColorTheme: COLOR_THEME,
      showMonthChart: true
    };
  },
  methods: {
    async renderChart(payload = {}) {
      const chartEle = this.$refs.chartEle;
      chartInstance = echarts.init(chartEle);

      this.loading = true;
      const resp = await fetchMonthContainerHistory(payload);
      this.loading = false;
      this.showMonthChart = false
      resp.forEach(v => {
        if (v.num){
          this.showMonthChart = true
        }
      });
      // 处理数据 使之符合表格
      let data = resp.map((v) => ({
        date: v.planArrivalDate,
        value: v,
      }));
      const dataMap = _.keyBy(
        data.map((v, index) => ({
          ...v.value,
          date: v.date,
          split: [0].includes(dayjs(v.date).month()), // 年分割
        })),
        "date"
      );

      chartInstance.setOption({
        grid: {
          left: "40px",
          right: "100px",
          bottom: "40px",
          top: "20px"
        },
        xAxis: {
          type: "category",
          data: data.map((v) => v.date),
          axisLabel: {
            interval: 0,
            formatter: (value, index) => {
              const isSame = dayjs(value).isSame(Date.now(), 'month')
              const date = dayjs(value).format("YY/MM");
              if (isSame) {
                return `${date}\r\n{red|(本月)}`
              }
              return date
            },
            rich: {
              red: {
                color: "red",
                padding: 4
              }
            }
          },
          maxInterval: 1,
          minInterval: 1,
          splitLine: {
            show: true,
            interval(_, v) {
              return dataMap[v].split;
            },
            lineStyle: {
              color: "#5c9bd1",
              type: "dotted",
            },
          },
          axisLine: {},
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          show: false,
        },
        series: [
          {
            type: "bar",
            barWidth: "20%",
            data: data.map((v) => v.value.num),
            label: {
              show: true,
              position: "top",
              formatter: (v) => {
                return  null
              },
              color: "black",
              rich: {
                orange: {
                  color: "#ff9100",
                  fontSize: 12,
                  padding: 4,
                },
              },
            },
            itemStyle: {
              color: "#3fb1e3",
            },
          },
        ],
      });
      return;
    },
    addWatcher() {
      fetchContainerPortAndNum({
        startDate:moment().endOf('month').subtract(24, "months").format("YYYY-MM-DD"),
        endDate:moment().endOf('month').format("YYYY-MM-DD")
      }).then((data) => {
        this.portList = data;
        this.portIdList = []
        if (data.length) {
          this.portIdList.push(this.portList[0].portId);
          if (Array.isArray(this.defaultPortIds) && this.defaultPortIds.length) {
            this.portIdList = _.cloneDeep(this.defaultPortIds)
          }
        }
        
        this.$watch("portIdList", {
          immediate: true,
          handler(val) {
            const payload = {
              portIds: this.portIdList,
            };
            this.renderChart({
              ...payload,
            });
          },
        });
        this.$watch("defaultPortIds", {
          handler(val) {
            if (Array.isArray(this.defaultPortIds) && this.defaultPortIds.length) {
              this.portIdList = _.cloneDeep(this.defaultPortIds)
            }
          },
        });

        // 使用默认
        this.$watch("portOptionList", {
          immediate: true,
          handler(val) {
            if (val.length) {
              this.portList = val
            }
          },
        })
      });
    }
  },
  computed: {
    disableCheckbox() {
      return this.portIdList.length <= 1;
    },
  },
  beforeDestroy() {
    chartInstance = null;
  },
};
</script>

<style lang="less">
.rectangle {
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #f09537;
}
#container-balance-month-chart {
  height: 280px;
}
.portCheckbox {
  transform: translate(-50%, 0px);
  position: absolute;
  left: 50%;
  top: 20px;
  font-size: 14px;
  width: 100%;
  text-align: center;
  .ivu-checkbox-wrapper {
    font-size: 14px;
  }
  .form-label {
    margin-right: 14px;
  }
}

</style>



// WEBPACK FOOTER //
// container-balance-month.vue?3a2de794